(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fope-watch-content"]) return;
  try {
    

  (function () {
    if (!document.querySelector('[id^="FopeWatchContent-"]')) return;
    document.body.classList.add('fope-watch-product-page');
    var stickyBar = document.querySelector('[data-fope-watch-sticky-buy]');
    var stickyButton = document.querySelector('[data-fope-watch-sticky-button]');

    function findMainButton() {
      var buttons = document.querySelectorAll('.product-section .add-to-cart');
      for (var i = 0; i < buttons.length; i += 1) {
        var rect = buttons[i].getBoundingClientRect();
        var styles = window.getComputedStyle(buttons[i]);
        if (rect.width > 0 && rect.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden') return buttons[i];
      }
      return buttons[0] || null;
    }

    var mainButton = findMainButton();
    if (!stickyBar || !stickyButton || !mainButton) return;

    var mobileViewport = window.matchMedia('(max-width: 768px)');
    var updateQueued = false;
    function setVisible(visible) {
      stickyBar.dataset.visible = visible ? 'true' : 'false';
      stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyButton.tabIndex = visible && !stickyButton.disabled ? 0 : -1;
      document.body.classList.toggle('fope-watch-sticky-buy-visible', visible);
    }
    stickyButton.addEventListener('click', function () {
      if (!stickyButton.disabled) mainButton.click();
    });
    function updateStickyVisibility() {
      updateQueued = false;
      mainButton = findMainButton() || mainButton;
      var mainButtonRect = mainButton.getBoundingClientRect();
      setVisible(mobileViewport.matches && window.scrollY > 240 && mainButtonRect.bottom < 0);
    }

    function queueVisibilityUpdate() {
      if (updateQueued) return;
      updateQueued = true;
      window.requestAnimationFrame(updateStickyVisibility);
    }
    window.addEventListener('scroll', queueVisibilityUpdate, { passive: true });
    window.addEventListener('resize', queueVisibilityUpdate);
    window.addEventListener('pageshow', queueVisibilityUpdate);

    if (mobileViewport.addEventListener) {
      mobileViewport.addEventListener('change', queueVisibilityUpdate);
    } else if (mobileViewport.addListener) {
      mobileViewport.addListener(queueVisibilityUpdate);
    }

    function syncVariant(event) {
      var variant = event && event.detail && event.detail.variant;
      var status = document.querySelector('[data-fope-availability]');
      if (variant && status) {
        var stocked = variant.available && variant.inventory_management && variant.inventory_policy === 'deny';
        var label = status.querySelector('[data-fope-availability-label]');
        if (label) label.textContent = !variant.available ? status.dataset.unavailable : stocked ? status.dataset.inStock + ' — ' + status.dataset.processing : status.dataset.order;
        var dot = status.querySelector('.fope-watch-product__availability-dot');
        if (dot) dot.hidden = !stocked;
      }
      stickyButton.disabled = mainButton.disabled;
      stickyButton.textContent = mainButton.textContent.trim();
      var price = document.querySelector('.product-section [data-product-price]');
      if (price) stickyBar.querySelector('.fope-watch-sticky-buy__details span').textContent = price.textContent;
      queueVisibilityUpdate();
    }
    new MutationObserver(function(){syncVariant();}).observe(mainButton,{attributes:true,childList:true,subtree:true});
    document.addEventListener('variant:change',syncVariant);
    document.querySelectorAll('.product-section .product__photo-zoom').forEach(function(button){button.setAttribute('aria-label',document.querySelector('[data-fope-watch-zoom-label]').dataset.fopeWatchZoomLabel);});
    syncVariant();
    updateStickyVisibility();
  }());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gabriel-watch-content"]) return;
  try {
    

  (function () {
    if (!document.querySelector('[id^="GabrielWatchContent-"]')) return;
    document.body.classList.add('gabriel-watch-product-page');
    var stickyBar = document.querySelector('[data-gabriel-watch-sticky-buy]');
    var stickyButton = document.querySelector('[data-gabriel-watch-sticky-button]');

    function findMainButton() {
      var buttons = document.querySelectorAll('.product-section .add-to-cart');
      for (var i = 0; i < buttons.length; i += 1) {
        var rect = buttons[i].getBoundingClientRect();
        var styles = window.getComputedStyle(buttons[i]);
        if (rect.width > 0 && rect.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden') return buttons[i];
      }
      return buttons[0] || null;
    }

    var mainButton = findMainButton();
    if (!stickyBar || !stickyButton || !mainButton) return;

    var mobileViewport = window.matchMedia('(max-width: 768px)');
    var updateQueued = false;
    function setVisible(visible) {
      stickyBar.dataset.visible = visible ? 'true' : 'false';
      stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyButton.tabIndex = visible && !stickyButton.disabled ? 0 : -1;
      document.body.classList.toggle('gabriel-watch-sticky-buy-visible', visible);
    }
    stickyButton.addEventListener('click', function () {
      if (!stickyButton.disabled) mainButton.click();
    });
    function updateStickyVisibility() {
      updateQueued = false;
      mainButton = findMainButton() || mainButton;
      var mainButtonRect = mainButton.getBoundingClientRect();
      setVisible(mobileViewport.matches && window.scrollY > 240 && mainButtonRect.bottom < 0);
    }

    function queueVisibilityUpdate() {
      if (updateQueued) return;
      updateQueued = true;
      window.requestAnimationFrame(updateStickyVisibility);
    }
    window.addEventListener('scroll', queueVisibilityUpdate, { passive: true });
    window.addEventListener('resize', queueVisibilityUpdate);
    window.addEventListener('pageshow', queueVisibilityUpdate);

    if (mobileViewport.addEventListener) {
      mobileViewport.addEventListener('change', queueVisibilityUpdate);
    } else if (mobileViewport.addListener) {
      mobileViewport.addListener(queueVisibilityUpdate);
    }

    function syncVariant(event) {
      var variant = event && event.detail && event.detail.variant;
      var status = document.querySelector('[data-gabriel-availability]');
      if (variant && status) {
        var stocked = variant.available && variant.inventory_management && variant.inventory_policy === 'deny';
        var label = status.querySelector('[data-gabriel-availability-label]');
        if (label) label.textContent = !variant.available ? status.dataset.unavailable : stocked ? status.dataset.inStock + ' — ' + status.dataset.processing : status.dataset.order;
        var dot = status.querySelector('.gabriel-watch-product__availability-dot');
        if (dot) dot.hidden = !stocked;
      }
      stickyButton.disabled = mainButton.disabled;
      stickyButton.textContent = mainButton.textContent.trim();
      var price = document.querySelector('.product-section [data-product-price]');
      if (price) stickyBar.querySelector('.gabriel-watch-sticky-buy__details span').textContent = price.textContent;
      queueVisibilityUpdate();
    }
    new MutationObserver(function(){syncVariant();}).observe(mainButton,{attributes:true,childList:true,subtree:true});
    document.addEventListener('variant:change',syncVariant);
    document.querySelectorAll('.product-section .product__photo-zoom').forEach(function(button){button.setAttribute('aria-label',document.querySelector('[data-gabriel-watch-zoom-label]').dataset.gabrielWatchZoomLabel);});
    syncVariant();
    updateStickyVisibility();
  }());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-discover"] && !Shopify.designMode) return;
  try {
    
(() => {
 const labels=()=>{
  const root=document.querySelector('[data-rc-discover]');if(!root)return;
  document.querySelectorAll('input[name="filter.p.m.custom.gemstone_type"]').forEach(input=>{
   const label=input.closest('label')?.querySelector('.tag__text');
   if(!label)return;
   if(input.value==='N/A'&&label.textContent!==root.dataset.goldLabel)label.textContent=root.dataset.goldLabel;
   if(input.value.split(',').length>3&&label.textContent!==root.dataset.mixedLabel)label.textContent=root.dataset.mixedLabel;
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',labels);else labels();
 document.addEventListener('shopify:section:load',labels);
 new MutationObserver(labels).observe(document.getElementById('MainContent')||document.body,{childList:true,subtree:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-product-assurance"] && !Shopify.designMode) return;
  try {
    
(() => {
 function setup(){
  document.querySelectorAll('[data-rc-enhancements]').forEach(root=>{
   if(root.dataset.ready)return;
   const primary=document.querySelector('[data-section-type="product"][data-modal="false"] button[data-add-to-cart]');
   const bar=root.querySelector('.rc-sticky'),button=root.querySelector('[data-rc-add]');
   if(!primary||!bar||!button)return;
   root.dataset.ready='true';
   document.querySelectorAll('[data-rc-zoom]').forEach(trigger=>{const zoom=trigger.closest('.product-single__sticky')?.querySelector('.product__photo-zoom');if(zoom){zoom.setAttribute('aria-label',trigger.textContent.trim());trigger.addEventListener('click',()=>zoom.click());}});
   let visible=true;
   const sync=()=>{button.disabled=primary.disabled;button.textContent=primary.textContent.trim();bar.hidden=visible||primary.disabled;const price=document.querySelector('[data-section-type="product"][data-modal="false"] [data-product-price]');if(price)bar.querySelector('span').textContent=price.textContent.trim();};
   button.addEventListener('click',()=>{if(!primary.disabled)primary.click();});
   new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:0}).observe(primary);
   new MutationObserver(sync).observe(primary,{attributes:true,childList:true,subtree:true});
   document.addEventListener('variant:change',event=>{sync();const status=document.querySelector('[data-rc-availability]');const variant=event.detail?.variant;if(!status||!variant)return;const label=status.querySelector('[data-rc-availability-label]');const stocked=variant.available&&variant.inventory_management&&variant.inventory_policy==='deny';if(label)label.textContent=!variant.available?status.dataset.unavailable:stocked?status.dataset.inStock+' — '+status.dataset.processing:status.dataset.order;const dot=status.querySelector('.rc-availability__dot');if(dot)dot.hidden=!stocked;});sync();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
 document.addEventListener('shopify:section:load',setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-watch-content"]) return;
  try {
    

  (function () {
    document.body.classList.add('rc-watch-product-page');
    var stickyBar = document.querySelector('[data-rc-watch-sticky-buy]');
    var stickyButton = document.querySelector('[data-rc-watch-sticky-button]');

    function findMainButton() {
      var buttons = document.querySelectorAll('.product-section .add-to-cart');
      for (var i = 0; i < buttons.length; i += 1) {
        var rect = buttons[i].getBoundingClientRect();
        var styles = window.getComputedStyle(buttons[i]);
        if (rect.width > 0 && rect.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden') return buttons[i];
      }
      return buttons[0] || null;
    }

    var mainButton = findMainButton();
    if (!stickyBar || !stickyButton || !mainButton) return;

    var mobileViewport = window.matchMedia('(max-width: 768px)');
    var updateQueued = false;
    function setVisible(visible) {
      stickyBar.dataset.visible = visible ? 'true' : 'false';
      stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyButton.tabIndex = visible && !stickyButton.disabled ? 0 : -1;
      document.body.classList.toggle('rc-watch-sticky-buy-visible', visible);
    }
    stickyButton.addEventListener('click', function () {
      if (!stickyButton.disabled) mainButton.click();
    });
    function updateStickyVisibility() {
      updateQueued = false;
      mainButton = findMainButton() || mainButton;
      var mainButtonRect = mainButton.getBoundingClientRect();
      setVisible(mobileViewport.matches && window.scrollY > 240 && mainButtonRect.bottom < 0);
    }

    function queueVisibilityUpdate() {
      if (updateQueued) return;
      updateQueued = true;
      window.requestAnimationFrame(updateStickyVisibility);
    }
    window.addEventListener('scroll', queueVisibilityUpdate, { passive: true });
    window.addEventListener('resize', queueVisibilityUpdate);
    window.addEventListener('pageshow', queueVisibilityUpdate);

    if (mobileViewport.addEventListener) {
      mobileViewport.addEventListener('change', queueVisibilityUpdate);
    } else if (mobileViewport.addListener) {
      mobileViewport.addListener(queueVisibilityUpdate);
    }

    function syncVariant(event) {
      var variant = event && event.detail && event.detail.variant;
      var status = document.querySelector('[data-rc-availability]');
      if (variant && status) {
        var stocked = variant.available && variant.inventory_management && variant.inventory_policy === 'deny';
        var label = status.querySelector('[data-rc-availability-label]');
        if (label) label.textContent = !variant.available ? status.dataset.unavailable : stocked ? status.dataset.inStock + ' — ' + status.dataset.processing : status.dataset.order;
        var dot = status.querySelector('.rc-watch-product__availability-dot');
        if (dot) dot.hidden = !stocked;
      }
      stickyButton.disabled = mainButton.disabled;
      stickyButton.textContent = mainButton.textContent.trim();
      var price = document.querySelector('.product-section [data-product-price]');
      if (price) stickyBar.querySelector('.rc-watch-sticky-buy__details span').textContent = price.textContent;
      queueVisibilityUpdate();
    }
    new MutationObserver(function(){syncVariant();}).observe(mainButton,{attributes:true,childList:true,subtree:true});
    document.addEventListener('variant:change',syncVariant);
    document.querySelectorAll('.product-section .product__photo-zoom').forEach(function(button){button.setAttribute('aria-label',document.querySelector('[data-rc-watch-zoom-label]').dataset.rcWatchZoomLabel);});
    syncVariant();
    updateStickyVisibility();
  }());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shy-watch-content"]) return;
  try {
    

  (function () {
    if (!document.querySelector('[id^="ShyWatchContent-"]')) return;
    document.body.classList.add('shy-watch-product-page');
    var stickyBar = document.querySelector('[data-shy-watch-sticky-buy]');
    var stickyButton = document.querySelector('[data-shy-watch-sticky-button]');

    function findMainButton() {
      var buttons = document.querySelectorAll('.product-section .add-to-cart');
      for (var i = 0; i < buttons.length; i += 1) {
        var rect = buttons[i].getBoundingClientRect();
        var styles = window.getComputedStyle(buttons[i]);
        if (rect.width > 0 && rect.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden') return buttons[i];
      }
      return buttons[0] || null;
    }

    var mainButton = findMainButton();
    if (!stickyBar || !stickyButton || !mainButton) return;

    var mobileViewport = window.matchMedia('(max-width: 768px)');
    var updateQueued = false;
    function setVisible(visible) {
      stickyBar.dataset.visible = visible ? 'true' : 'false';
      stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyButton.tabIndex = visible && !stickyButton.disabled ? 0 : -1;
      document.body.classList.toggle('shy-watch-sticky-buy-visible', visible);
    }
    stickyButton.addEventListener('click', function () {
      if (!stickyButton.disabled) mainButton.click();
    });
    function updateStickyVisibility() {
      updateQueued = false;
      mainButton = findMainButton() || mainButton;
      var mainButtonRect = mainButton.getBoundingClientRect();
      setVisible(mobileViewport.matches && window.scrollY > 240 && mainButtonRect.bottom < 0);
    }

    function queueVisibilityUpdate() {
      if (updateQueued) return;
      updateQueued = true;
      window.requestAnimationFrame(updateStickyVisibility);
    }
    window.addEventListener('scroll', queueVisibilityUpdate, { passive: true });
    window.addEventListener('resize', queueVisibilityUpdate);
    window.addEventListener('pageshow', queueVisibilityUpdate);

    if (mobileViewport.addEventListener) {
      mobileViewport.addEventListener('change', queueVisibilityUpdate);
    } else if (mobileViewport.addListener) {
      mobileViewport.addListener(queueVisibilityUpdate);
    }

    function syncVariant(event) {
      var variant = event && event.detail && event.detail.variant;
      var status = document.querySelector('[data-shy-availability]');
      if (variant && status) {
        var stocked = variant.available && variant.inventory_management && variant.inventory_policy === 'deny';
        var label = status.querySelector('[data-shy-availability-label]');
        if (label) label.textContent = !variant.available ? status.dataset.unavailable : stocked ? status.dataset.inStock + ' — ' + status.dataset.processing : status.dataset.order;
        var dot = status.querySelector('.shy-watch-product__availability-dot');
        if (dot) dot.hidden = !stocked;
      }
      stickyButton.disabled = mainButton.disabled;
      stickyButton.textContent = mainButton.textContent.trim();
      var price = document.querySelector('.product-section [data-product-price]');
      if (price) stickyBar.querySelector('.shy-watch-sticky-buy__details span').textContent = price.textContent;
      queueVisibilityUpdate();
    }
    new MutationObserver(function(){syncVariant();}).observe(mainButton,{attributes:true,childList:true,subtree:true});
    document.addEventListener('variant:change',syncVariant);
    document.querySelectorAll('.product-section .product__photo-zoom').forEach(function(button){button.setAttribute('aria-label',document.querySelector('[data-shy-watch-zoom-label]').dataset.shyWatchZoomLabel);});
    syncVariant();
    updateStickyVisibility();
  }());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  function syncSlides(root) {
    root.querySelectorAll('[data-section-type="slideshow-section"]').forEach(function (section) {
      if (section.dataset.gtjFocusReady) return;
      section.dataset.gtjFocusReady = 'true';
      var slides = section.querySelectorAll('.slideshow__slide');
      function sync() {
        slides.forEach(function (slide) {
          var hidden = slide.getAttribute('aria-hidden');
          slide.inert = hidden === 'true' || (hidden === null && !slide.closest('.flickity-enabled') && slide.dataset.index !== '0');
        });
      }
      sync();
      var observer = new MutationObserver(sync);
      slides.forEach(function (slide) {
        observer.observe(slide, {attributes: true, attributeFilter: ['aria-hidden']});
      });
      document.addEventListener('shopify:section:unload', function cleanup(event) {
        if (!event.target.contains(section)) return;
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', cleanup);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncSlides(document); });
  } else {
    syncSlides(document);
  }
  document.addEventListener('shopify:section:load', function () { syncSlides(document); });
})();

  } catch(e) { console.error(e); }
})();
})();
